import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import '@/styles/main.scss';

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
// import LoadIcon from '@/components/LoadIcon';
import lodash from 'lodash'
import VueLodash from 'vue-lodash'
import VueMoment from 'vue-moment'
import 'moment-timezone' // Add timezone support to moment
import VueTimers from 'vue-timers'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import TextHighlight from 'vue-text-highlight'
import draggable from 'vuedraggable'
import ToggleButton from 'vue-js-toggle-button'
// set up IziToast
import VueIziToast from 'vue-izitoast';
import 'izitoast/dist/css/iziToast.min.css';

// Set up SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';


export function configureGlobalImports () {
// global components
  Vue.use(ToggleButton)
  Vue.use(BootstrapVue)
  Vue.use(VueLodash, { lodash: lodash })
  Vue.use(VueMoment)
  Vue.use(VueTimers)
  Vue.use(VueIziToast, {
    position: 'topRight',
    transitionIn: 'flipInX',
    transitionOut: 'flipOutX',
    closeOnEscape: true,
    animateInside: false
  });

  Vue.use(VueSweetalert2, {
    reverseButtons: false
  });


  Vue.component('v-date-picker', DatePicker)
  Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker)
  Vue.component('v-multiselect', Multiselect)
  // Vue.component('load-icon', LoadIcon)
  Vue.component('text-highlight', TextHighlight)
  Vue.component('draggable', draggable)

  if (window.navigator.language === 'en-GB') {
    require('moment/locale/en-gb')
  }
}
